import { BrowserRouter } from 'react-router-dom';
import Navbar from './Components/Navbar/Navbar';
import Container from './Components/Container/Container';

const Router = () => {
  return (
    <BrowserRouter>
      <Navbar />
      <Container />
    </BrowserRouter>
  );
};

export default Router;
